export default class {
  constructor(name, api) {
    const me = this;
    /**
     * state
     */
    me.state = {
      /**
       * Cấu hình của module
       */
      _config: {
        field: {},
      },
      /**
       * loading
       */
      loading: false,
      /**
       * loading load summary
       */
      loadingSummary: false,
      /**
       * Tổng bản ghi theo paging
       */
      total: 0,
      /**
       * Thông tin tổng
       */
      summary: null,
      /**
       * active data - dùng cho combobox
       */
      items: [],
      /**
       * Không có dữ liệu trong bảng
       * Dùng cờ này để hiển thị mặc hình trống trên danh sách
       */
      empty: false,
      /**
       * Tổng tiền
       */
      totalAmount: 0,
      /**
       * Số tiền đã thanh toán
       */
      paidAmount: 0,
      /**
       * Só tiền còn lại
       */
      remainAmount: 0,
    };

    /**
     * actions
     */
    me.actions = {
      /**
       * Lấy đường dẫn controller api
       */
      getController() {
        return api.getAPIUrl();
      },

      async export(context, payload) {
        await api.export(payload || {});
      },

      /**
       * Load danh sách
       */
      async load(context, payload) {
        let res = null;
        try {
          context.commit("updateLoading", true);
          res = await api.getList(payload || {});
        } finally {
          context.commit("updateLoading", false);
        }
        if (res) {
          context.commit("setItems", { result: res, payload: payload });
        }

        return res;
      },

      /**
       * Load danh sách
       */
      async loadSummary(context, payload) {
        let res = null;
        try {
          context.commit("updateLoadingSummary", true);
          res = await api.getList(payload || {});
        } finally {
          context.commit("updateLoadingSummary", false);
        }

        if (res) {
          context.commit("setItems", { result: res, payload: payload });
        }

        return res;
      },

      /**
       * Load danh sách
       */
      async full(context, payload) {
        //context.commit("updateLoading", true);

        let res = await api.getFullList();
        //context.commit("updateLoading", false);

        if (res) {
          // res.skip = payload ? payload.skip : 0;
          res.payload = payload;
          context.commit("setAllItems", res);
        }

        return res;
      },
      /**
       * Load dữ liệu để thêm/sửa/nhân bản
       * Hàm này sẽ không commit mà return value để binding cho form
       */
      async get(context, payload) {
        let method = "get" + payload.action;
        delete payload.action;

        let res = await api[method](payload);
        return res;
      },
      /**
       * Thêm mới
       */
      async insert(context, payload) {
        let res = await api.insert(payload);
        if (res && res.Success) {
          if (res.Data) {
            //cập nhật danh sách
            context.commit("insertItem", res.Data);
          }
        }
        return res;
      },
      /**
       * Cập nhật
       */
      async update(context, payload) {
        let res = await api.update(payload);
        if (res && res.Success) {
          if (res.Data) {
            //cập nhật danh sách
            context.commit("updateItem", res.Data);
          }
        }
        return res;
      },
      /**
       * Xóa
       */
      async delete(context, payload) {
        let res = await api.delete(payload);
        if (res && res.Success) {
          //cập nhật danh sách
          let deleteSucessItems = payload.Entity;
          context.commit("deleteItems", deleteSucessItems);
        }
        return res;
      },
    };

    /**
     * mutations
     */
    let defaultState = {};
    Object.assign(defaultState, me.state);
    me.mutations = {
      resetState(state) {
        Object.assign(state, defaultState);
      },
      setItems(state, data) {
        if (data.result) {
          for (let i in data.result) {
            let resultValue = data.result[i];
            switch (i) {
              case "PageData":
                state.items.removeAll();
                state.items.append(resultValue);
                break;
              case "items":
                state.items.removeAll();
                state.items.append(resultValue);
                break;
              case "totalCount":
              case "Total":
                state.total = resultValue;
                break;
              case "Empty":
                state.empty = resultValue;
                break;
              case "Summary":
                state.summary = resultValue;
                break;
              case "TotalAmount":
              case "totalAmount":
                state.totalAmount = resultValue;
                break;
              case "PaidAmount":
              case "paidAmount":
                state.paidAmount = resultValue;
                break;
              case "RemainAmount":
              case "remainAmount":
                state.remainAmount = resultValue;
                break;
            }
          }
        }

        // state.items.removeAll();
        // state.items.append(res.PageData);
        // if (!res.payload || !res.payload.skip) {
        //   state.total = res.Total;
        //   state.empty = res.Empty;
        // }
      },
      setSummary(state, res) {
        state.summary = res;
      },
      setAllItems(state, res) {
        state.items.removeAll();
        state.items.append(res);
      },
      addNew(state, item) {
        state.items.push(item);
      },
      updateLoading(state, data) {
        state.loading = data;
      },
      updateLoadingSummary(state, data) {
        state.loadingSummary = data;
      },
      setItem(state, data) {
        state.item = data;
      },
      setTotalAmount(state, data) {
        state.totalAmount = data;
      },
      setPaidAmount(state, data) {
        state.paidAmount = data;
      },
      setRemainAmount(state, data) {
        state.remainAmount = data;
      },
      /**
       * Cập nhật khi thêm bản ghi
       * modifiedby: nmsinh 3/4/2021 : xử lý trường extdata
       */
      insertItem(state, data) {
        let newItem = { ...data };
        if (newItem.ExtData) {
          let ext = JSON.parse(newItem.ExtData);
          for (let i in ext) {
            newItem[i] = ext[i];
          }
        }
        state.items.insertAt(0, newItem);
        state.total += 1;
        //pvduy 11/05/2021 cất thành công thì cập nhật lại cờ empty để render lại giao diện.
        state.empty = false;
      },
      /**
       * Cập nhật khi sửa bản ghi
       */
      updateItem(state, data) {
        let keyField = state._config.field.key;

        if (keyField) {
          let id = data[keyField];
          for (let i = 0; i < state.items.length; i++) {
            let item = state.items[i];

            if (item[keyField] === id) {
              Object.assign(item, data);
            }
          }
        }
      },
      /**
       * Cập nhật khi xóa bản ghi
       */
      deleteItems(state, items) {
        let keyField = state._config.field.key;

        if (keyField) {
          let count = items.length;
          for (let k = 0; k < count; k++) {
            let id = items[k][keyField];
            for (let i = 0; i < state.items.length; i++) {
              let item = state.items[i];

              if (item[keyField] === id) {
                state.items.remove(item);
                break;
              }
            }
          }

          state.total -= count;
        }
      },
    };

    /**
     * getters
     */
    me.getters = {};
    for (let i in me.state) {
      me.getters[i] = function (state) {
        return state[i];
      };
    }
  }
}
